import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { errorTexts } from '../configs/error-text';
import { formPatterns } from '../configs/form-patterns';

@Injectable({
  providedIn: 'root',
})
export class FormErrorService {
  public getErrorKey(control: AbstractControl): string {
    const errors = control.errors;
    if (!errors) return;
    if (errors.required) return 'required';
    let error = Object.keys(errors)[0];
    const detail = Object.values(errors)[0];
    if (detail && detail.requiredPattern) {
      const detailedError = formPatterns.find(p => p.pattern === detail.requiredPattern);
      if (detailedError) error = detailedError.key;
      else console.warn(detailedError, detail.requiredPattern);
    }

    return error;
  }

  public getFieldError(control: AbstractControl): string {
    const error = this.getErrorKey(control);
    if (!error) return;

    let errorText = errorTexts[error];

    if (!errorText) {
      errorText = 'Undefined error';
      // console.warn('Error text not specified', error);
    }

    if (error === 'minlength') {
      errorText = errorText.split('$MINLENGTH').join(control.errors.minlength.requiredLength);
    }
    if (error === 'maxlength') {
      errorText = errorText.split('$MAXLENGTH').join(control.errors.maxlength.requiredLength);
    }

    return errorText;
  }
}
